import { useSessionStore } from './session.store';
import { type SessionStatus, type SessionUser } from './session.types';

/**
 * Selectores de sesion.
 *
 * Cada uno devuelve el trozo mas pequeno posible para que un componente que
 * solo mira los permisos no se vuelva a renderizar cuando cambia el token.
 */

export function useSessionStatus(): SessionStatus {
  return useSessionStore((state) => state.status);
}

export function useCurrentUser(): SessionUser | null {
  return useSessionStore((state) => state.user);
}

export function useIsAuthenticated(): boolean {
  return useSessionStore((state) => state.status === 'activa');
}

/**
 * Comprueba un permiso.
 *
 * Esto es comodidad de interfaz, NO seguridad: sirve para no ensenar acciones
 * que el servidor rechazaria. La autorizacion real ocurre en el backend, que
 * lee los permisos del token firmado y nunca de lo que envie el cliente.
 * Ocultar un boton no protege nada: quien quiera llamar al endpoint lo hara
 * igual.
 */
export function useHasPermission(permission: string): boolean {
  return useSessionStore((state) => state.user?.permissions.has(permission) ?? false);
}

/** Requiere TODOS los permisos indicados, igual que el guard del backend. */
export function useHasEveryPermission(permissions: readonly string[]): boolean {
  return useSessionStore((state) => {
    const held = state.user?.permissions;
    if (held === undefined) return false;

    return permissions.every((permission) => held.has(permission));
  });
}

export function useMustChangePassword(): boolean {
  return useSessionStore((state) => state.user?.mustChangePassword ?? false);
}
